var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.315 0.5H10.205C4.56574 0.5 0 5.06632 0 10.7063V40.8263C0 46.46 4.56574 51.0263 10.205 51.0263H40.3213C45.9543 51.0263 50.5263 46.46 50.5263 40.82V10.7063C50.52 5.06632 45.9543 0.5 40.315 0.5Z",
    fill: "url(#paint0_linear_11017_9919)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.044 12.1082L26.067 10.3398C26.6985 9.23449 28.1067 8.86186 29.2119 9.49344C30.317 10.125 30.6896 11.5334 30.0581 12.6387L20.2004 29.704H27.33C29.6413 29.704 30.9359 32.4198 29.9318 34.3019H9.02913C7.7535 34.3019 6.73047 33.2787 6.73047 32.0029C6.73047 30.7271 7.7535 29.704 9.02913 29.704H14.8894L22.3917 16.6998L20.0488 12.6324C19.4173 11.5271 19.7899 10.1313 20.895 9.48713C22.0001 8.85555 23.3958 9.22818 24.0399 10.3334L25.044 12.1082ZM16.1777 36.6703L13.9675 40.504C13.336 41.6092 11.9277 41.9819 10.8226 41.3503C9.71746 40.7187 9.34488 39.3103 9.97638 38.205L11.6183 35.3629C13.4749 34.7882 14.9842 35.2303 16.1777 36.6703ZM35.2111 29.7166H41.1914C42.4671 29.7166 43.4901 30.7398 43.4901 32.0155C43.4901 33.2913 42.4671 34.3145 41.1914 34.3145H37.8697L40.1116 38.205C40.7431 39.3103 40.3705 40.7061 39.2653 41.3503C38.1602 41.9819 36.7646 41.6092 36.1205 40.504C32.3441 33.9545 29.5087 29.0534 27.6268 25.7882C25.7007 22.4661 27.0774 19.1313 28.4351 18.0008C29.9444 20.5903 32.1989 24.4998 35.2111 29.7166Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11017_9919",
    x1: 25.2632,
    y1: 0.5,
    x2: 25.2632,
    y2: 51.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18BFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2072F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.9390e4521dc38a63c689e48714bf4b1f.svg";
export { ForwardRef as ReactComponent };